export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20collage%20with%20colorful%20sneakers%20denim%20jacket%20cap%20and%20accessories%20scattered%20on%20warm%20beige%20surface%2C%20soft%20morning%20sunlight%20from%20left%2C%20shallow%20depth%20of%20field%2C%20editorial%20magazine%20style%2C%20elegant%20neutral%20aesthetic%2C%20minimal%20composition%2C%20high%20end%20fashion%20photography&width=1800&height=1200&seq=hero-hoobuy-v2-main&orientation=landscape"
          alt="Hoobuy Spreadsheet - Coleção de moda internacional"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-0">
        <div className="flex flex-col items-start max-w-3xl">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/90 text-foreground-950 text-xs font-semibold mb-6 whitespace-nowrap tracking-wide">
            HoobuySpreadsheet 2026
          </span>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-6">
            A Planilha Mais<br />
            Completa para<br />
            <span className="text-accent-400">Comprar com Segurança</span>
          </h1>

          <p className="text-background-200 text-base md:text-lg max-w-xl mb-8 leading-relaxed">
            Descubra a forma mais rápida e inteligente de usar o <strong className="text-background-50">Hoobuy Spreadsheet</strong> para encontrar produtos baratos, comparar preços e comprar com segurança em 2026.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-accent-500 text-foreground-950 font-semibold text-sm cursor-pointer whitespace-nowrap hover:bg-accent-400 transition-all duration-200"
            >
              Acessar HoobuySpreadsheet
              <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a
              href="/guia-de-compras"
              className="flex items-center justify-center gap-2 px-7 py-3.5 rounded-full border-2 border-background-300 bg-background-50/10 text-background-50 font-medium text-sm cursor-pointer whitespace-nowrap hover:bg-background-50/20 transition-all duration-200"
            >
              Ver Todos os Guias
              <i className="ri-article-line w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}